import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

type QueryParamsNavLinkProps = {
  children: React.ReactNode;
  className: (isActive: boolean) => string;
  queryParam: string;
  queryParamValue: string;
  to: string;
};

const QueryParamsNavLink = ({
  children,
  className,
  queryParam,
  queryParamValue,
  to,
}: QueryParamsNavLinkProps) => {
  const [searchParams] = useSearchParams();
  const isActive = searchParams.get(queryParam) === queryParamValue;
  return (
    <Link className={className(isActive)} to={to}>
      {children}
    </Link>
  );
};

export default QueryParamsNavLink;
